import { usePhoneCallStore } from 'src/stores/phoneCall';

import { AbstractPollingPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractPollingPhoneCallGatewayStrategy';
import { PollingPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/PollingPhoneCallGatewayStrategy';

import { isFirefox } from 'src/util/platform';
import { QueryStore } from 'src/util/query/QueryStore';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export class CallToPollingPhoneCallGatewayStrategy
	extends AbstractPollingPhoneCallGatewayStrategy
	implements PollingPhoneCallGatewayStrategy
{
	constructor(phoneCallStore: PhoneCallStore, queryStore: QueryStore) {
		super(phoneCallStore, queryStore);
	}

	public async makeCall(_: string, toNumber: string): Promise<null | string> {
		const timestamp = String(Math.floor(Date.now() / 1000));

		if (isFirefox()) {
			window.location.href = `callto:${toNumber}`;
		} else {
			window.open(`callto:${toNumber}`, '_system');
		}

		return await this.nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp(toNumber, timestamp);
	}
}
